const appId = 'com.poliooutbreaks.app';
export { appId };
